import { render, staticRenderFns } from "./InformationPermissionLevel.vue?vue&type=template&id=96ac9bb2&scoped=true"
import script from "./InformationPermissionLevel.vue?vue&type=script&lang=js"
export * from "./InformationPermissionLevel.vue?vue&type=script&lang=js"
import style0 from "./InformationPermissionLevel.vue?vue&type=style&index=0&id=96ac9bb2&prod&scoped=true&lang=css"
import style1 from "./InformationPermissionLevel.vue?vue&type=style&index=1&id=96ac9bb2&prod&lang=css"
import style2 from "./InformationPermissionLevel.vue?vue&type=style&index=2&id=96ac9bb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ac9bb2",
  null
  
)

export default component.exports